import { getImageUrl } from './getImageUrl'
import { normalizeImageName } from './normalizeImageName'

export const getTokenImage = (symbol: string | 'fallback') => {
  if (symbol === 'USDm') {
    return getImageUrl('tokens', 'usdmegaeth')
  }

  switch (symbol.toLowerCase()) {
    case 'btc.b':
    case 'btcb':
    case 'ubtc':
      return getImageUrl('tokens', 'btc')
    case 'dai.e':
      return getImageUrl('tokens', 'dai')
    case 'usdc.e':
    case 'verusdc':
    case 'abasusdc':
    case 'waethusdc':
    case 'vbusdc':
    case 'bbqusdc':
      return getImageUrl('tokens', 'usdc')
    case 'usdt.e':
    case 'vbusdt':
      return getImageUrl('tokens', 'usdt')
    case 'weth.e':
    case 'ueth':
    case 'waethweth':
    case 'vbeth':
      return getImageUrl('tokens', 'weth')
    case 'wpol':
    case 'pol':
      return getImageUrl('tokens', 'matic')
    case 'wstusr':
      return getImageUrl('tokens', 'usr')
    case 'wusdm':
      return getImageUrl('tokens', 'usdm')
    case 'usd₮':
    case 'waethusdt':
      return getImageUrl('tokens', 'usdt')
    case 'usd₮0':
      return getImageUrl('tokens', 'usdt0')
    case 'reul':
      return getImageUrl('tokens', 'eul')
    case 'aethusds':
      return getImageUrl('tokens', 'usds')
    case 'wswell':
      return getImageUrl('tokens', 'swell')
    case 'bb.snect':
      return getImageUrl('tokens', 'nect')
    case 'wsuperoethb':
    case 'wsuperoeth':
      return getImageUrl('tokens', 'woethb')
    case 'wbnb':
      return getImageUrl('tokens', 'bnb')
    case 'mtwcarrot':
      return getImageUrl('tokens', 'carrot')
    case 'aethusdc':
      return getImageUrl('tokens', 'ausdc')
    case 'aethusdt':
      return getImageUrl('tokens', 'ausdt')
    case 'aethweth':
      return getImageUrl('tokens', 'aweth')
    case 'eth+':
      return getImageUrl('tokens', 'ethplus')
    case 'usd0++':
      return getImageUrl('tokens', 'usd0plusplus')
    case 'aethrlusd':
    case 'ahorrwarlusd':
      return getImageUrl('tokens', 'arlusd')
    case 'aarbarb':
      return getImageUrl('tokens', 'aarbarb')
    case 'aave.e':
      return getImageUrl('tokens', 'aave')
    case 'link.e':
      return getImageUrl('tokens', 'link')
    case 'wbtc.e':
    case 'vbwbtc':
      return getImageUrl('tokens', 'wbtc')
    case 'wrseth':
      return getImageUrl('tokens', 'rseth')

    case 'fallback':
      return getImageUrl('tokens', 'unknownToken')

    default:
      return getImageUrl('tokens', normalizeImageName('tokens', symbol))
  }
}
